import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { Button, Popup } from "devextreme-react";

import { store } from "@/store/store";
import { usePopupDisplay } from "@/hooks/usePopupDisplay";
import { hideDialogInfo, selectDialogInfo } from "@/redux/shareSlice";
import { DialogType } from "@/shared/enums";

const PopupDialog = () => {
  const { popupVisible, showPopUp, hidePopup } = usePopupDisplay();
  const { isShow, title, content, okText, cancelText, dialogType, okAction } = useSelector(selectDialogInfo);

  useEffect(() => {
    isShow && showPopUp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShow]);

  const dialogStyle = useMemo(() => {
    switch (dialogType) {
      case DialogType.info:
        return "dx-popup-title-info";

      case DialogType.warning:
        return "dx-popup-title-warning";

      case DialogType.error:
        return "dx-popup-title-error";
    }
  }, [dialogType]);

  const handleOkClick = async () => {
    closeDialog();
    okAction && (await okAction());
  };

  const closeDialog = () => {
    hidePopup();
    store.dispatch(hideDialogInfo({}));
  };

  return (
    <>
      {popupVisible && (
        <Popup
          className="dx-customize-popup-dialog"
          titleRender={() => (
            <div
              className={dialogStyle}
              style={{
                color: "white", // Text color
                padding: "10px",
                width: "100%",
                fontSize: "20px",
              }}
            >
              {title}
            </div>
          )}
          width={600}
          height={"auto"}
          title={title}
          visible={popupVisible}
          onHiding={closeDialog}
          showCloseButton={true}
        >
          <div dangerouslySetInnerHTML={{ __html: content }} />
          <hr></hr>
          <div className="d-flex justify-content-end">
            <Button type="default" onClick={handleOkClick}>
              {okText ?? "Ok"}
            </Button>
            <Button type="normal" className="ms-4" onClick={closeDialog}>
              {cancelText ?? "Cancel"}{" "}
            </Button>
          </div>
        </Popup>
      )}
    </>
  );
};

export default PopupDialog;
